import { Component, OnInit, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { DataService } from '../../services/data/data.service';
import { Deficiences } from '../../models/deficiences';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-audit-processing',
  templateUrl: './audit-processing.html',
  styleUrls: ['./audit-processing.css'],
  imports: [DatePipe], // Add this using the DatePipe Directive in the template
})

  @Injectable({
    providedIn: 'root' // Add this line for LocalStorageService
  })

export class AuditComplete implements OnInit {
  claimant: Deficiences;
 
  constructor(
    private storage: LocalStorageService,
    private dataService: DataService,

  ) { }

  ngOnInit() {
    this.claimant = this.storage.retrieve('claimant');
    this.dataService.getData();
  }
}
